import { useTranslation } from '@mc/i18n'
import { useStaticData } from '@mc/static-data-react'
import { EmailCapture } from 'components/EmailCapture'
import { ArticleItem } from 'types/data'
import AsideList from '../AsideList'
import { LatestArticles } from '../LatestArticles'

const Details = () => {
  const { t } = useTranslation('@mc/next')
  const { topArticles, latestArticles, totalLatestArticles } = useStaticData<{
    topArticles: Array<ArticleItem>
    latestArticles: Array<ArticleItem>
    totalLatestArticles: number
  }>()

  return (
    <section className='container' data-testid='details'>
      <EmailCapture
        className='mc-bg-gray-700 mc-p-6'
        trackProps={{
          location: 'articles_home_page_body_slim_banner',
          campaign: 'articles',
        }}
        thankYouText={t('emailCaptureBanner.form.success.description')}
      >
        <h2 className='mc-text-h4'>{t('articles.emailCapture.title')}</h2>
        <p className='mc-opacity--muted mc-my-4'>
          {t('articles.emailCapture.description')}
        </p>
      </EmailCapture>
      <div className='row no-gutters'>
        <div className='col-lg-8 col-sm-12'>
          <div className='mc-pr-8'>
            <LatestArticles
              latestArticles={latestArticles}
              totalLatestArticles={totalLatestArticles}
            />
          </div>
        </div>
        <div className='col-4 d-none d-lg-block'>
          {topArticles.length && (
            <AsideList
              title={t('article.topArticle.title')}
              items={topArticles}
            />
          )}
        </div>
      </div>
    </section>
  )
}

export default Details
